import { CloseIcon, WarningTwoIcon } from '@chakra-ui/icons';
import {
  AlertIcon,
  Box,
  Heading,
  HStack,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  useToast,
  VStack
} from '@chakra-ui/react';
import axios from 'axios';
import {
  MutableRefObject,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { WhiteLabelWrapper } from '../../../../components/layouts/WhiteLabelWrapper';
import { WhiteLabelNavigator } from '../../../../components/navigation/WhiteLabelNavigator';
import { WhiteLabelSteps } from '../../../../components/white-label/WhiteLabelSteps';
import { StepsFormActions } from '../../../../contexts/StepsContext';
import { useStepsForm } from '../../../../hooks/useStepsForm';
import { apiSensedia } from '../../../../services/api-sensedia';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

export const StepThree = (): JSX.Element => {
  const { state, setState } = useStepsForm();
  const { idWebsite } = useParams();

  const [dataListPartner, setDataListPartner] = useState<any[]>();
  const [dataListIntermediacao, setDataListIntermediacao] = useState<any[]>();

  const [openBoxAlert, setOpenBoxAlert] = useState(false);

  const fieldsInputRefBrokerage =
    useRef() as MutableRefObject<HTMLSelectElement>;

  const fieldsInputRefAgency = useRef() as MutableRefObject<HTMLSelectElement>;

  const fieldsInputRefFrequency =
    useRef() as MutableRefObject<HTMLSelectElement>;

  const fieldsInputRefRegisteredPartner =
    useRef() as MutableRefObject<HTMLSelectElement>;

  const fieldsInputRefPercentage =
    useRef() as MutableRefObject<HTMLSelectElement>;

  const toast = useToast();
  const navigate = useNavigate();

  const getPartner = async (partner: boolean) => {
    if (partner) {
      setState({
        type: StepsFormActions.setPartner,
        payload: partner
      });
      try {
        // const res = await axios.get(
        //   'https://jsonplaceholder.typicode.com/users'
        // );
        const res2 = await apiWl.get(`/parceiros`);
        // console.log('dados evs', res.data);
        console.log('dados evs 2', res2.data);
        setDataListPartner(res2.data);
      } catch (error) {
        console.log(error);
        setOpenBoxAlert(true);
      }
    }
    if (!partner) {
      setState({
        type: StepsFormActions.setPartner,
        payload: partner
      });
    }
  };

  const handleGetWebsite = async () => {
    try {
      const res = await apiWl.get(`/websites/${idWebsite}`);
      console.log('dados carregados', res.data);
      setState({
        type: StepsFormActions.setBrokerage,
        payload: res.data.corretagem
      });
      setState({
        type: StepsFormActions.setAgency,
        payload: res.data.agenciamento
      });
      setState({
        type: StepsFormActions.setFrequency,
        payload: res.data.periodicidade
      });
      setState({
        type: StepsFormActions.setRegisteredPartner,
        payload: res.data.ev_parceria
      });
      setState({
        type: StepsFormActions.setPercentage,
        payload: res.data.intermediacao
      });
      setState({
        type: StepsFormActions.setPartner,
        payload: res.data.ev_parceria && res.data.intermediacao
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handlePutWebsite = useCallback(async () => {
    try {
      const body = {
        corretagem: state.brokerage,
        agenciamento: state.agency,
        periodicidade: state.frequency,
        contains_sulamerica_logo: state.logoSulamerica,
        ev_parceria: Number(state.registeredPartner),
        intermediacao: state.percentage
      };
      const res = await apiWl.put(`/websites/${idWebsite}`, body);
    } catch (error) {
      console.log(error);
    }
  }, [state]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    /*if (!state.partner) {
      console.log(state.partner);
      toast({
        position: 'top',
        description: `O preenchimento do campo: Existe pagamento ao parceiro? é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else*/
    if (fieldsInputRefBrokerage.current.value === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefBrokerage.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefAgency.current.value === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefAgency.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
      // } else if (fieldsInputRefFrequency.current.value === '') {
      //   toast({
      //     position: 'top',
      //     description: `O preenchimento do campo: ${fieldsInputRefFrequency.current.id} é obrigatório`,
      //     status: 'error',
      //     duration: 10000,
      //     isClosable: true
      //   });
    } else if (
      state.partner &&
      fieldsInputRefRegisteredPartner.current.value === ''
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefRegisteredPartner.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (state.partner && fieldsInputRefPercentage.current.value === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefPercentage.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else {
      handlePutWebsite();
      navigate(`/corretor/white-label/step-four/${idWebsite}/`);
    }
  };

  const [options] = useState([0]);

  const handleOptions = async () => {
    const extension = 100;
    for (let i = 1; i <= extension; i++) {
      await options.push(i);
    }
  };

  useEffect(() => {
    handleGetWebsite();
    window.scrollTo(0, 0);
    handleOptions();
  }, []);

  useEffect(() => {
    const intermedList = Array.from(
      { length: Number(state.brokerage) - 1 },
      (_, i) => i + 1
    );
    setDataListIntermediacao(intermedList);
    // console.log('lista intermed', intermedList);
  }, [state.brokerage]);

  useEffect(() => {
    getPartner(true);
  }, []);

  setTimeout(() => {
    if (openBoxAlert) {
      setOpenBoxAlert(false);
      setState({
        type: StepsFormActions.setPartner,
        payload: false
      });
    }
  }, 3500);

  return (
    <WhiteLabelWrapper>
      <Box p="40px 56px">
        <VStack gap="30px">
          <HStack w="100%" justifyContent="space-between">
            <Box>
              <Heading
                fontSize="2rem"
                fontWeight="700"
                lineHeight="3rem"
                color="#000000"
              ></Heading>
              <Text
                mt="10px"
                fontSize="1rem"
                fontWeight="400"
                lineHeight="1.5rem"
                color="#323232"
              >
                Escolha a sua remuneração e pagamento.
              </Text>
            </Box>
            <WhiteLabelSteps currentStep={3} />
          </HStack>

          <Stack
            bg="#FFFFFF"
            w="100%"
            p="30px"
            m="0 !important"
            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="24px"
          >
            <Heading
              fontSize="1.5rem"
              fontWeight="700"
              lineHeight="2rem"
              color="#001E64"
            >
              Remuneração e pagamento
            </Heading>
            <HStack
              mt="30px !important"
              display="flex"
              justifyContent="space-between"
              bgt="red"
            >
              <Box m="0px !important" w="320px">
                <Text
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#202020"
                >
                  Escolha sua corretagem*
                </Text>
                <Select
                  id="Escolha sua corretagem"
                  ref={fieldsInputRefBrokerage}
                  value={state.brokerage}
                  onChange={async (e) => {
                    setState({
                      type: StepsFormActions.setAgency,
                      payload: ''
                    });
                    setState({
                      type: StepsFormActions.setBrokerage,
                      payload: e.target.value
                    });
                  }}
                  mt="10px"
                  h="50px"
                  borderRadius="6px"
                  bg="#FFFFFF"
                  border="1px solid #001E64 !important"
                  placeholder="Corretagem"
                  _placeholder={{
                    color: '#828282',
                    fontSize: '1rem',
                    fontWeight: '400',
                    lineHeight: '1.5rem'
                  }}
                  _hover={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                  _active={{}}
                >
                  <option value="2">
                    {state.percentage
                      ? (2 - Number(state.percentage)).toString()
                      : '2'}
                    %
                  </option>
                  <option value="10">
                    {state.percentage
                      ? (10 - Number(state.percentage)).toString()
                      : '10'}
                    %
                  </option>
                  <option value="20">
                    {state.percentage
                      ? (20 - Number(state.percentage)).toString()
                      : '20'}
                    %
                  </option>
                  <option value="27">
                    {state.percentage
                      ? (27 - Number(state.percentage)).toString()
                      : '27'}
                    %
                  </option>
                  <option value="30">
                    {state.percentage
                      ? (30 - Number(state.percentage)).toString()
                      : '30'}
                    %
                  </option>
                </Select>
              </Box>

              <Box m="0px !important" w="320px">
                <Text
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#202020"
                >
                  Escolha seu agenciamento*
                </Text>
                <Select
                  id="Escolha sua agenciamento"
                  ref={fieldsInputRefAgency}
                  value={state.agency}
                  onChange={(e) => {
                    setState({
                      type: StepsFormActions.setAgency,
                      payload: e.target.value
                    });
                  }}
                  mt="10px"
                  h="50px"
                  borderRadius="6px"
                  bg="#FFFFFF"
                  border="1px solid #001E64 !important"
                  placeholder="Agenciamento"
                  _placeholder={{
                    color: '#828282',
                    fontSize: '1rem',
                    fontWeight: '400',
                    lineHeight: '1.5rem'
                  }}
                  _hover={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                  _active={{}}
                >
                  {state.brokerage === '2' ? (
                    <option value={options[100]}>{options[100]}%</option>
                  ) : state.brokerage === '27' ? (
                    <option value={options[100] + 50}>
                      {options[100] + 50}%
                    </option>
                  ) : (
                    <>
                      <option value={options[0]}>{options[0]}%</option>
                      <option value={options[100]}>{options[100]}%</option>
                    </>
                  )}
                </Select>
              </Box>

              <Box m="0px !important" w="320px">
                {/* <Text
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#202020"
                >
                  Escolha sua periodicidade de pagamento*
                </Text> */}
                {/* <Select
                  id="Escolha sua periodicidade de pagamento"
                  ref={fieldsInputRefFrequency}
                  value={state.frequency || undefined}
                  onChange={(e) => {
                    setState({
                      type: StepsFormActions.setFrequency,
                      payload: e.target.value
                    });
                  }}
                  mt="10px"
                  h="50px"
                  borderRadius="6px"
                  bg="#FFFFFF"
                  border="1px solid #001E64 !important"
                  placeholder="Periodicidade"
                  _placeholder={{
                    color: '#828282',
                    fontSize: '1rem',
                    fontWeight: '400',
                    lineHeight: '1.5rem'
                  }}
                  _hover={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                  _active={{}}
                >
                  <option value="A">Anual</option>
                </Select> */}
              </Box>
            </HStack>
          </Stack>

          <Stack
            bg="#FFFFFF"
            w="100%"
            p="30px"
            m="0 !important"
            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
            borderRadius="24px"
          >
            <Heading
              fontSize="1.5rem"
              fontWeight="700"
              lineHeight="2rem"
              color="#001E64"
            >
              Parceiro
            </Heading>
            <HStack
              mt="30px !important"
              display="flex"
              justifyContent="space-between"
              bgt="red"
            >
              <Box m="0px !important" w="320px">
                <Text
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#202020"
                >
                  Existe pagamento ao parceiro?
                </Text>
                <RadioGroup
                  mt="10px !important"
                  value={state.partner ? 'Y' : 'N'}
                >
                  <Stack direction="row">
                    <Radio
                      value="Y"
                      borderColor="#001E64"
                      colorScheme="orange"
                      _focus={{ outline: '0 !important' }}
                      onClick={() => getPartner(true)}
                    >
                      Sim
                    </Radio>
                    <Radio
                      value="N"
                      borderColor="#001E64"
                      colorScheme="orange"
                      _focus={{ outline: '0 !important' }}
                      onClick={() => {
                        getPartner(false);
                        setState({
                          type: StepsFormActions.setRegisteredPartner,
                          payload: ''
                        });
                        setState({
                          type: StepsFormActions.setPercentage,
                          payload: ''
                        });
                      }}
                    >
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </Box>
              <Box
                m="0px !important"
                w="320px"
                visibility={state.partner ? 'visible' : 'hidden'}
              >
                <Text
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#202020"
                >
                  Escolha o parceiro cadastrado*
                </Text>
                <Select
                  id="Escolha o parceiro cadastrado"
                  ref={fieldsInputRefRegisteredPartner}
                  value={state.registeredPartner}
                  onChange={async (e) => {
                    setState({
                      type: StepsFormActions.setRegisteredPartner,
                      payload: e.target.value
                    });
                  }}
                  mt="10px"
                  h="50px"
                  borderRadius="6px"
                  bg="#FFFFFF"
                  border="1px solid #001E64 !important"
                  placeholder="Parceiro cadastrado"
                  _placeholder={{
                    color: '#828282',
                    fontSize: '1rem',
                    fontWeight: '400',
                    lineHeight: '1.5rem'
                  }}
                  _hover={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                  _active={{}}
                >
                  {dataListPartner?.map((item, index) => {
                    return (
                      <option key={index} value={item.cod_estr_venda}>
                        {item.cod_estr_venda} - {item.nome}
                      </option>
                    );
                  })}
                </Select>
              </Box>
              <Box
                m="0px !important"
                w="320px"
                visibility={state.partner ? 'visible' : 'hidden'}
              >
                <Text
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#202020"
                >
                  Escolha o percentual*
                </Text>
                <Select
                  id="Escolha o percentual"
                  ref={fieldsInputRefPercentage}
                  disabled={!state.brokerage}
                  value={state.percentage}
                  onChange={async (e) => {
                    setState({
                      type: StepsFormActions.setPercentage,
                      payload: e.target.value
                    });
                  }}
                  mt="10px"
                  h="50px"
                  borderRadius="6px"
                  bg="#FFFFFF"
                  border="1px solid #001E64 !important"
                  placeholder="Percentual"
                  _placeholder={{
                    color: '#828282',
                    fontSize: '1rem',
                    fontWeight: '400',
                    lineHeight: '1.5rem'
                  }}
                  _hover={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                  _active={{}}
                >
                  {dataListIntermediacao?.map((item, index) => {
                    return (
                      <option key={index} value={item}>
                        {item}%
                      </option>
                    );
                  })}
                </Select>
              </Box>
            </HStack>
            {openBoxAlert && (
              <Box
                w="100%"
                bg="#FACED2"
                m="25px 0 0 0 !important"
                p="15px"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                borderRadius="6px"
              >
                <Box display="flex" gridGap="10px" alignItems="center">
                  <WarningTwoIcon color="#d60404" w="18px" h="18px" />
                  <Text>
                    Não localizamos parceiros vinculados a sua estrutura,
                    contate o seu gestor de vendas e saiba como cadastrar
                  </Text>
                </Box>

                <CloseIcon onClick={() => setOpenBoxAlert(false)} />
              </Box>
            )}
          </Stack>

          <WhiteLabelNavigator
            hrefPrev={`/corretor/white-label/step-two/${state.idWebsite}`}
            nextAction={(e: any) => {
              handleSubmit(e);
            }}
            btnNextText={'Salvar e Continuar'}
          />
        </VStack>
      </Box>
    </WhiteLabelWrapper>
  );
};
